module.exports = __webpack_public_path__ + "media/images/icons/check-c90d7c37afe96bd7970442f49845aa62.svg";